import type { AppConfig } from '../types/runtime-config'

function getEmptyConfig(): AppConfig {
  return {
    apiBaseUrl: '',
    region: '',
    userPoolId: '',
    userPoolClientId: '',
    cognitoDomain: '',
    appVersion: ''
  }
}

export async function loadAppConfig(): Promise<AppConfig> {
  const config = getEmptyConfig()

  try {
    const response = await fetch('/config.json', { cache: 'no-store' })
    if (response.ok) {
      const runtimeConfig = (await response.json()) as Partial<AppConfig>
      Object.assign(config, runtimeConfig)
    } else {
      console.warn('Could not load /config.json; runtime config missing')
    }
  } catch (error) {
    console.warn('Error loading /config.json; runtime config missing', error)
  }

  window.__APP_CONFIG__ = config
  return config
}

export function getAppConfig(): AppConfig {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__
  }

  return getEmptyConfig()
}
